<template>
  <div>
    <BreadCrumbHeader
      title="Fredericka English"
      subTitle="UX Designer"
      :leftButton="breadCrumbLeftButton"
      lastCrumb="Resume"
    />
    <div class="container">
      <div class="row">
        <div class="col-md-10 col-sm-12 col-md-offset-1">
          <!-- POST -->
          <div class="post">
            <div class="post-header">
              <h2 class="post-title">Summary</h2>
            </div>
            <div class="post-content">
              <p>
                Focused and versatile problem-solver with a comprehensive user experience background and 5+ years of hands-on experience. Well-versed in project development and deployment, including enterprise, customer facing products, design systems, websites, and mobile applications. Leads and executes detail-oriented challenges while improving processes and staying true to client objectives.  Recognized as a collaborative team member that exceeds expectations by creating valuable partnerships and joining forces with people at all levels of the organization, including stakeholders, customers, vendors, and team members.
              </p>
              <div class="post-header">
                <h2 class="post-title">Core Skills</h2>
              </div>
              <blockquote class="single-blockquote">
                <p>
                  <span
                    v-for="(features,skill,pos) in skills"
                    v-bind:key="pos"
                    class="skill-container"
                  >
                    <strong>■ {{ skill }}: </strong>
                    <span> {{ features.join(" | ") }} </span>
                  </span>
                </p>
              </blockquote>
            </div>
          </div>
          <div class="comments">
            <h5 class="text-uppercase widget-title">Professional Experience</h5>
            <div v-for="(workExperience, index) in experience" v-bind:key="index" class="comment">
              <div class="comment-avatar">
                <img :src="workExperience.logo" alt />
              </div>
              <div class="comment-tools hidden-xs">{{workExperience.location}}</div>
              <div class="comment-content">
                <h5>{{workExperience.title}}</h5>
                <h6>{{workExperience.date}}</h6>
                <h6 class="visible-xs-block">{{workExperience.location}}</h6>
                <p>{{workExperience.brief}}</p>
                <ul>
                  <li
                    v-for="(relevantPoint,relevanceIndex) in workExperience.relevance"
                    v-bind:key="relevanceIndex"
                  >{{ relevantPoint}}</li>
                </ul>
              </div>
            </div>
          </div>
          <h5 class="text-uppercase widget-title">Education</h5>
          <div class="row multi-columns-row">
            <div class="col-sm-4 col-md-4 col-lg-4 mb-40" v-for="(educationEntry,index) in education" :key="index">
              <div class="resume-education">
                <h5>{{educationEntry.title}}</h5>
                <p>
                  {{educationEntry.school}} <br />
                  {{educationEntry.date}} <br />
                  {{educationEntry.location}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbHeader from "@/components/elements/BreadCrumbHeader.vue";

export default {
  components: {
    BreadCrumbHeader,
  },
  data() {
    return {
      breadCrumbLeftButton: {
        text: "Download PDF",
        link: "/fe_resume.pdf",
      },
      skills: {
        Design: [
          "User Experience Design",
          "User Interface Design",
          "Information Architecture",
          "Visual Design",
          "Prototyping",
          "Usability Testing",
        ],
        Tools: [
          "Figma",
          "Sketch",
          "Illustrator",
          "Photoshop",
          "After Effects",
          "InVision",
        ],
        Development: ["HTML", "CSS"],
        Bilingual: ["English", "Spanish"],
      },
      education: [
        {
          "title": "B.A. in Animation and Digital Arts",
          "school": "Tecnologico de Monterrey",
          "date": "2007 - 2011",
          "location": "Guadalajara, Mexico"
        },
        {
          "title": "International semester in Communication and Media Arts",
          "school": "University of Tampa",
          "date": "2010",
          "location": "Tampa, FL"
        },
        {
          "title": "User experience Design Circuit Certification",
          "school": "General Assembly",
          "date": "2017",
          "location": "Seattle, WA"
        }
      ],
      experience: [
        {
          title: "Microsoft - User Experience Designer",
          logo:
            "/images/resume/logo_microsoft.png",
          date: "February 2020 - June 2020",
          location: "Bellevue, Washington",
          brief:
            "Created and implemented user experience improvements for a behavior analytics tool, owned the user experience design piece and translated business requirements into new features and scalable user interface.",
          relevance: [
            "Conceived, designed, and established a behavior analytics tool which provides clients with the capability to understand how users are interacting with their website through features such as session replays and heatmaps",
            "Aligned business strategy and requirements with user needs to deliver a competitive advantage with exceptional design concepts, scenarios, and user flows",
            "Executed the translation of business requirements into a modern and scalable user interface with intuitive navigation",
          ],
        },
        {
          title: "Microsoft - User Experience Designer",
          logo:
            "/images/resume/logo_microsoft.png",
          date: "February 2018 - December 2019",
          location: "Redmond, Washington",
          brief:
            "Collaborated with cross-functional engineering teams to enhance multiple internal processes, tools and Windows design system for Windows 10 and Windows 10X.",
          relevance: [
            "Utilized behavior metrics and user telemetry data to improve accessibility tools (Magnifier - Cursor & pointer) for the Windows 1019H1 update",
            "Revised and designed reusable cross-platform components for existing and new Windows design systems, facilitating the design of faster and scalable experiences across different platforms",
            "Established cross-platform components libraries for Windows 10 and the upcoming 10X OS version for dual-screen devices, delivering coherence and consistency in design system language",
          ],
        },
        {
          title: "Propelics - User Experience Designer",
          logo: "/images/resume/logo_prop.png",
          date: "March 2015 - March 2017",
          location: "Guadalajara, Mexico",
          brief:
            "Engaged with the business development team and clients to develop, redesign, and implement mobile applications in alignment with customer business goals.",
          relevance: [
            "Created an enterprise mobile application for Cintas, utilized by 6K+ drivers nationwide, resulting in improved customer service, increased productivity, and simplified workflow",
            "Remodeled and enhanced the Bright Horizons Back-Up Care mobile application, identified and prioritized features for improvement, delivered a reservation feature which reduced user frustration and led to increased reservations via the mobile app",
          ],
        },
        {
          title: "Alteacorp - Content Designer",
          logo:
            "/images/resume/logo_altea.png",
          date: "April 2013 - February 2015",
          location: "Guadalajara, Mexico",
          brief:
            "Collaborated with technical team members to produce 2D/3D content for video projections utilized during live events, aligning the visual and motion style to realize an immersive experience.",
          relevance: [
          ],
        },
         {
          title: "Protarget - Visual Designer",
          logo:
            "/images/resume/logo_prot.png",
          date: "February 2012 - March 2013",
          location: "Guadalajara, Mexico",
          brief:
            "Designed custom marketing materials in adherence with client marketing campaign requirements and objectives, improving user experience and increasing web and social media traffic.",
          relevance: [
          ],
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
$left-column-bg-color: #454546;
$left-column-text-color: rgba(255, 255, 255, 0.6);
$resume-padding-top: 50px;
$resume-padding-bottom: 40px;
$ion-font-size: 24px;

@media only screen and (max-width: 992px) {
  #resume-full-left {
    background: none !important;
  }
}
#resume-full-left {
  background: linear-gradient(
    to right,
    $left-column-bg-color,
    $left-column-bg-color calc(50% - 400px),
    white calc(50% - 400px),
    white 100%
  );
}

h5.widget-title {
  font-size: 20px;
  font-weight: 400;
}

.comments {
  margin-bottom: 20px;
  .comment-content {
    h6 {
      text-transform: capitalize;
    }
    p {
      font-style: italic;
    }
  }
}
ul li {
  list-style: square;
  margin-left: 16px;
}
.comment-avatar img {
  border: 2px solid #f5f5f5;
}

.resume-education > h5 {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 2px;
  margin-bottom: 5px;
}
</style>